import {
  ReportSection,
  RestoreAllDataButton,
  ThumbRatingContainer,
  WarningFooter,
} from '@/reports/index';
import { commonTypes } from '@/reports/types';
import { PhoneCard } from './PhoneCard';

export interface PhoneSectionProps {
  phonesCount: number;
  personName: string;
  phoneList: commonTypes.Phones;
  permalink: string;
  alternateTitle?: string;
}

export function PhoneSection({
  phonesCount,
  personName,
  phoneList,
  permalink,
  alternateTitle,
}: PhoneSectionProps) {
  return (
    <ReportSection
      title={alternateTitle || 'Possible Phone Numbers'}
      sectionDescription={`Phone numbers that ${personName} may currently or previously have used are displayed below. Run a phone report on a particular number to search for more information.`}
      sectionId="phone-numbers-section"
      hasContent={phonesCount > 0}
      personName={personName}
      FooterComponent={<WarningFooter />}
    >
      {phoneList.map((phone) => (
        <ThumbRatingContainer
          item={phone}
          key={phone.number}
          component={PhoneCard}
          dataPropKey="phone"
          permalink={permalink}
          cardProps={{ ownerName: personName }}
        />
      ))}
      <RestoreAllDataButton items={phoneList} permalink={permalink} />
    </ReportSection>
  );
}
